export const MODULE_LABELS = {
  dashboard: "Dashboard",
  outlets: "Outlets",
  sales: "Sales",
  revenue: "Revenue",
  cash: "Cash Management",
  inventory: "Inventory",
  recipes: "Recipe / Food Cost",
  procurement: "Procurement",
  suppliers: "Suppliers",
  expenses: "Expenses",
  budget: "Budget",
  pnl: "Profit & Loss",
  reports: "Reports",
  users: "Staff / Users",
  approvals: "Approvals",
  notifications: "Notifications",
  audit: "Audit Logs",
  settings: "Settings",
};

export const ACTION_LABELS = {
  view: "View",
  create: "Create",
  edit: "Edit",
  delete: "Delete",
  approve: "Approve",
  export: "Export",
};

export const moduleLabel = (m) => MODULE_LABELS[m] || m;
export const actionLabel = (a) => ACTION_LABELS[a] || a;
